import {atom} from 'recoil';
import {NavigationBarProps} from "../../models/layout";

/**
 * 네비게이션 바의 상태
 */
export const navbarInitialState: NavigationBarProps = {
    pageTitle: "",
    hasBackButton: true,
    hasSettingsButton: false,
    backgroundColor: "white",
}

export const navbarState = atom<NavigationBarProps>({
    key: 'navigationBarState',
    default: navbarInitialState,
});

/**
 * 사이드바 활성화 여부 관리하는 상태
 */
export const sidebarActiveState = atom<boolean>({
    key: 'sidebarActiveState',
    default: false,
});

/**
 * 컴포넌트 로딩 상태
 */
export const isLoadingState = atom<boolean>({
    key: 'isLoadingState',
    default: false,
})
